<template>
  <div class="fill-height">
    <div class="fill-height">


      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-row justify="center">
          <v-col cols="12" lg="4">

            <div class="text-center">
              <div class="titlePage">
                ورود و مشاهده تراپیست پیشنهادی
              </div>
              <div class="descPage">
                جهت مشاهده نتیجه تحلیل و معرفی تراپیست های مناسب شما، کافیست وارد شوید...
              </div>
            </div>
            <div class="authFormBox">
              <div class="headerForm" v-if="state == 'getEmailRegister'">
                <v-tabs
                    v-model="tab"
                    fixed-tabs
                    class="pa-0 ma-0"
                    color="#39C990"
                >
                  <v-tab color="pa-0 ma-0" value="morning">ایجاد حساب کاربری</v-tab>
                  <v-tab color="pa-0 ma-0" value="evening">ورود به حساب</v-tab>
                </v-tabs>
              </div>
              <div v-else>
                <img class="mt-2" src="../../assets/image/user-journey/arrow-narrow-right_1.svg" alt=""
                     @click="returnStep">
              </div>
              <v-tabs-items v-model="tab" touchless>
                <v-tab-item>
                  <v-fade-transition mode="out-in">
                    <div :key="1" v-if="state == 'getEmailRegister'">
                      <div class="titleAuthBox">
                        ایجاد حساب کاربری
                      </div>
                      <div class="subTitle">
                        لطفا ایمیل خود را جهت ایجاد حساب کاربری وارد کنید
                      </div>

                      <div class="googleAuthBtn" @click="loginWithGoogle">
                        <div class="d-flex justify-center">
                          <div class="mt-1">
                            <img src="../../assets/image/user-journey/google.png" width="16px" alt="">
                          </div>
                          <div class="mr-2 d-flex flex-column justify-center">
                            ادامه با حساب گوگل
                          </div>
                        </div>
                      </div>
                      <div class="orSection">
                        <div class="line mt-2"></div>
                        <div class="label">یا</div>
                        <div class="line mt-2"></div>
                      </div>
                      <div class="formBox">
                        <div :class="showEmailError ? 'errorForm' : 'customInputGrey'" cols="12" lg="6">
                          <v-text-field @keydown.native.enter="registerWithEmail()" v-model="email" outlined
                                        :color="showEmailError ? 'red' : 'black'"
                                        label="ایمیل"></v-text-field>
                          <div v-if="showEmailError" class="red--text hintAreaAuth mb-5 d-flex">
                            <div>
                              <img src="../../assets/image/user-journey/info-circle-red.svg" alt="">
                            </div>
                            <div class="mr-1 d-flex justify-center flex-column">
                              شما قبلا با این ایمیل حساب کاربری ساخته اید
                            </div>
                          </div>
                        </div>
                        <v-btn
                            @click="registerWithEmail"
                            class="submitBtn"
                            :disabled="!isValidEmail"
                            elevation="0"
                        >
                          ایجاد حساب کاربری
                        </v-btn>
                      </div>
                      <div class="line"></div>

                      <div class="loginBtn">
                        حساب کاربری دارید؟
                        <span style="color:#39C990;cursor:pointer;" @click="tab = 1">
                ورود به حساب کاربری
                </span>
                      </div>
                    </div>
                    <div :key="2" v-if="state == 'getCodeRegister'">
                      <div class="titleAuthBox">
                        کد تایید
                      </div>
                      <div class="subTitle">
                        کد تایید ایجاد حساب کاربری ، به ایمیل زیر ارسال شد
                      </div>
                      <br>
                      <div class="hintAreaAuth text-center mb-5"
                           style="font-size: 14px;font-family: YekanBakh ,Roboto !important;color: #FF6E6E">
                        درصورت عدم دریافت کد تایید، spam ایمیل خود را بررسی کنید.
                      </div>
                      <div class="emailBox d-flex flex-column ">
                        <div class="d-flex  justify-space-between">
                          <div class="flex-grow-1 emailLabel">
                            {{ email }}
                          </div>
                          <div class="d-flex flex-column justify-center" style="cursor: pointer">
                            <img src="../../assets/image/user-journey/pencil.svg" @click="state = 'getEmailRegister'"
                                 alt="">
                          </div>
                        </div>
                      </div>
                      <div class="otpArea customInputGrey">
                        <v-otp-input
                            style="direction: ltr;border-color: red"
                            @finish="submitRegisterEmail"
                            length="6"
                            v-model="otp"
                            type="number"
                        ></v-otp-input>
                      </div>
                      <v-btn
                          @click="submitRegisterEmail"
                          class="submitBtn"
                          :disabled="!isValidEmail"
                          elevation="0"
                      >
                        تایید
                      </v-btn>
                      <div class="resendArea" @click="registerWithEmail" style="cursor:pointer;">
                        کد را دریافت نکرده اید؟
                        <span style="color:#39C990;" class="mr-1">
                  ارسال مجدد
                </span>
                      </div>
                      <div class="line"></div>
                      <div class="loginBtn">
                        میخواهید از رمز عبور استفاده کنید؟
                        <span style="color:#39C990;cursor:pointer;" @click="state = 'getPasswordRegister'">
                تعریف رمز عبور
                </span>
                      </div>
                    </div>
                    <div :key="3" v-if="state == 'getPhoneRegister'">
                      <div class="titleAuthBox">
                        شماره تلفن همراه
                      </div>
                      <div class="subTitle">
                        جهت یادآوری جلسات و هماهنگی سریع، لطفا شماره‌ تلفن خود را وارد کنید
                      </div>
                      <div class="otpArea customInputGrey">
                        <v-form ref="changePhone" @keydown.native.enter="changePhoneNumber"
                                @submit.prevent="changePhoneNumber">
                          <v-text-field
                              type="tel"
                              inputmode="numeric"
                              v-model="phone"
                              :rules="phoneRulesWithMessage"
                              outlined
                              color="black"
                              label="شماره واتس اپ / تلگرام"></v-text-field>
                        </v-form>

                        <div class="hintAreaAuth d-flex">
                          <div>
                            <img src="../../assets/image/user-journey/info.svg" alt="">
                          </div>
                          <div class="mr-1 d-flex justify-center flex-column">
                            لطفاً شماره‌ای وارد کنید که در واتساپ یا تلگرام فعال باشد.
                          </div>
                        </div>

                        <div style="margin-top: 100px">
                          <v-btn
                              @click="changePhoneNumber"
                              class="submitBtn mb-5"
                              elevation="0"
                          >
                            ثبت و مشاهده تراپیست
                          </v-btn>
                        </div>
                      </div>
                    </div>
                    <div :key="4" v-if="state == 'getPasswordRegister'">
                      <div class="titleAuthBox">
                        تعریف رمز عبور
                      </div>
                      <div class="subTitle">
                        برای دسترسی آسان به حساب کاربری خود، رمز عبور تعیین کنید.
                      </div>
                      <div class="otpArea customInputGrey">
                        <v-form ref="changePhone"

                                @keydown.native.enter="savePassword(null)" @submit.prevent="savePassword(null)"
                        >
                          <v-text-field
                              v-model="password"
                              outlined
                              :type="typePassword"
                              color="black"
                              placeholder="رمز عبور">
                            <template v-slot:append>
                              <div style="cursor: pointer">
                                <img v-if="typePassword == 'password'" @click="typePassword = 'text'"
                                     src="../../assets/image/user-journey/eye-off.svg" alt="">
                                <img @click="typePassword = 'password'" v-else
                                     src="../../assets/image/user-journey/eye.svg">
                              </div>
                            </template>
                          </v-text-field>
                          <v-text-field
                              style="margin-top: -15px"
                              v-model="RePassword"
                              :type="typeRePassword"
                              outlined
                              color="black"
                              placeholder="تکرار رمز عبور">
                            <template v-slot:append>
                              <div style="cursor: pointer">
                                <img v-if="typeRePassword == 'password'" @click="typeRePassword = 'text'"
                                     src="../../assets/image/user-journey/eye-off.svg" alt="">
                                <img @click="typeRePassword = 'password'" v-else
                                     src="../../assets/image/user-journey/eye.svg">
                              </div>
                            </template>
                          </v-text-field>
                        </v-form>
                        <div class="hintAreaAuthPassword ">
                          <div class="hintItem d-flex">
                            <div class="hintIcon d-flex flex-column justify-center">
                              <img src="../../assets/image/user-journey/check-list-active.svg"
                                   v-if="validations.minLength"
                                   alt="">
                              <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                            </div>
                            <div class="hintText mr-1 d-flex flex-column justify-center">
                              حداقل ۸ کاراکتر
                            </div>
                          </div>
                          <div class="hintItem d-flex">
                            <div class="hintIcon d-flex flex-column justify-center">
                              <img src="../../assets/image/user-journey/check-list-active.svg"
                                   v-if="validations.upperLower"
                                   alt="">
                              <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                            </div>
                            <div class="hintText mr-1 d-flex flex-column justify-center">
                              شامل حروف انگلیسی بزرگ و کوچک
                            </div>
                          </div>
                          <div class="hintItem d-flex">
                            <div class="hintIcon d-flex flex-column justify-center">
                              <img src="../../assets/image/user-journey/check-list-active.svg" v-if="validations.number"
                                   alt="">
                              <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                            </div>
                            <div class="hintText mr-1 d-flex flex-column justify-center">
                              استفاده از اعداد
                            </div>
                          </div>
                          <div class="hintItem d-flex">
                            <div class="hintIcon d-flex flex-column justify-center">
                              <img src="../../assets/image/user-journey/check-list-active.svg" v-if="validations.symbol"
                                   alt="">
                              <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                            </div>
                            <div class="hintText mr-1 d-flex flex-column justify-center">
                              استفاده از نمادها (مانند ! @ # $)
                            </div>
                          </div>
                        </div>

                        <div style="margin-top: 40px">
                          <v-btn
                              @click="savePassword(null)"
                              class="submitBtn"
                              elevation="0"
                              :disabled="!validations.allValid || !RePassword"
                              style="margin-bottom: 16px !important;"
                          >
                            ذخیره رمز عبور
                          </v-btn>
                          <div class="line"></div>
                          <div class="loginBtn">
                            حساب کاربری دارید؟
                            <span style="color:#39C990;">
                ورود به حساب
                        </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-fade-transition>
                </v-tab-item>
                <v-tab-item>
                  <v-fade-transition mode="out-in">
                    <div :key="1" v-if="state == 'getEmailRegister'">
                      <div class="titleAuthBox">
                        ورود به حساب
                      </div>
                      <div class="subTitle">
                        لطفا اطلاعات خود را جهت ورود به حساب کاربری وارد کنید
                      </div>

                      <div class="googleAuthBtn" @click="loginWithGoogle">
                        <div class="d-flex justify-center">
                          <div class="mt-1">
                            <img src="../../assets/image/user-journey/google.png" width="16px" alt="">
                          </div>
                          <div class="mr-2 d-flex flex-column justify-center">
                            ادامه با حساب گوگل
                          </div>
                        </div>
                      </div>
                      <div class="orSection">
                        <div class="line mt-2"></div>
                        <div class="label">یا</div>
                        <div class="line mt-2"></div>
                      </div>
                      <div class="formBox">
                        <div :class="showEmailError ? 'errorForm' : 'customInputGrey'" cols="12" lg="6">
                          <v-text-field
                              @keydown.native.enter="Object.keys(loginMethods).length == 0 ? getLoginMethod() : login()"
                              v-model="email" outlined :color="showEmailError ? 'red' : 'black'"
                              label="ایمیل"></v-text-field>
                          <v-form ref="loginForm"
                                  @submit.prevent="Object.keys(loginMethods).length == 0 ? getLoginMethod() : login()"
                                  @keydown.native.enter="Object.keys(loginMethods).length == 0 ? getLoginMethod() : login()"
                          >
                            <v-text-field
                                @keydown.native.enter="login"
                                :rules="requiredRulesWithoutMessage"
                                v-model="password"
                                outlined
                                style="margin-top: -15px"
                                :type="typePassword"
                                color="black"
                                v-if="loginMethods.password"
                                placeholder="رمز عبور">
                              <template v-slot:append>
                                <div style="cursor: pointer">
                                  <img v-if="typePassword == 'password'" @click="typePassword = 'text'"
                                       src="../../assets/image/user-journey/eye-off.svg" alt="">
                                  <img @click="typePassword = 'password'" v-else
                                       src="../../assets/image/user-journey/eye.svg">
                                </div>
                              </template>
                            </v-text-field>

                          </v-form>
                          <div style="margin-top: -20px;z-index: 5;position: relative">
                            <div class="loginOption" v-if="loginMethods.email" @click="sendOtpLogin">
                              ورود با رمز یکبار مصرف
                            </div>
                            <div class="loginOption" v-if="Object.keys(loginMethods).length != 0"
                                 @click="state = 'getEmailForgetPassword'">
                              رمز عبورخود را فراموش کرده اید؟
                            </div>
                          </div>
                          <div v-if="showEmailError" class="red--text hintAreaAuth mb-5 d-flex">
                            <div>
                              <img src="../../assets/image/user-journey/info-circle-red.svg" alt="">
                            </div>
                            <div class="mr-1 d-flex justify-center flex-column">
                              کاربری با این ایمیل ثبت نام نکرده است
                            </div>
                          </div>

                        </div>
                        <v-btn
                            @click="Object.keys(loginMethods).length == 0 ? getLoginMethod() : login()"
                            class="submitBtn mt-5"
                            :disabled="!isValidEmail"
                            elevation="0"
                        >
                          ورود به حساب
                        </v-btn>
                      </div>
                      <div class="line"></div>

                      <div class="loginBtn">
                        حساب کاربری ندارید؟
                        <span style="color:#39C990;cursor:pointer;" @click="tab = 0">
                ایجاد حساب کاربری
                </span>
                      </div>
                    </div>
                    <div :key="2" v-if="state == 'getOtpLogin'">
                      <div class="titleAuthBox">
                        کد تایید
                      </div>
                      <div class="subTitle">
                        کد تایید ورود به حساب کاربری ، به
                        <b>
                          ایمیل زیر
                        </b>
                        ارسال شد
                      </div>
                      <br>
                      <div class="hintAreaAuth text-center mb-5"
                           style="font-size: 14px;font-family: YekanBakh ,Roboto !important;color: #FF6E6E">
                        درصورت عدم دریافت کد تایید، spam ایمیل خود را بررسی کنید.
                      </div>
                      <div class="emailBox d-flex flex-column ">
                        <div class="d-flex  justify-space-between">
                          <div class="flex-grow-1 emailLabel">
                            {{ email }}
                          </div>
                          <div class="d-flex flex-column justify-center" style="cursor: pointer">
                            <img src="../../assets/image/user-journey/pencil.svg" @click="state = 'getEmailRegister'"
                                 alt="">
                          </div>
                        </div>
                      </div>
                      <div class="otpArea customInputGrey">
                        <v-otp-input
                            style="direction: ltr;border-color: red"
                            @finish="submitCodeLogin"
                            length="6"
                            v-model="otp"
                        ></v-otp-input>
                        <v-btn
                            @click="submitCodeLogin"
                            class="submitBtn"
                            :disabled="!isValidEmail"
                            elevation="0"
                        >
                          تایید
                        </v-btn>
                      </div>
                      <div class="resendArea" @click="registerWithEmail" style="cursor:pointer;">
                        کد را دریافت نکرده اید؟
                        <span style="color:#39C990;" class="mr-1">
                  ارسال مجدد
                </span>
                      </div>
                    </div>
                    <div :key="3" v-if="state == 'getPhoneLogin'">
                      <div class="titleAuthBox">
                        شماره تلفن همراه
                      </div>
                      <div class="subTitle">
                        جهت یادآوری جلسات و هماهنگی سریع، لطفا شماره‌ تلفن خود را وارد کنید
                      </div>
                      <div class="otpArea customInputGrey">
                        <v-form ref="changePhone"
                                @keydown.native.enter="changePhoneNumber"
                                @submit.prevent="changePhoneNumber"
                        >
                          <v-text-field
                              type="tel"
                              inputmode="numeric"
                              v-model="phone"
                              :rules="phoneRulesWithMessage"
                              outlined
                              color="black"
                              label="شماره واتس اپ / تلگرام"></v-text-field>
                        </v-form>

                        <div class="hintAreaAuth d-flex">
                          <div>
                            <img src="../../assets/image/user-journey/info.svg" alt="">
                          </div>
                          <div class="mr-1 d-flex justify-center flex-column">
                            لطفاً شماره‌ای وارد کنید که در واتساپ یا تلگرام فعال باشد.
                          </div>
                        </div>

                        <div style="margin-top: 100px">
                          <v-btn
                              @click="changePhoneNumber"
                              class="submitBtn"
                              elevation="0"

                          >
                            ثبت و مشاهده تراپیست
                          </v-btn>
                        </div>
                      </div>
                    </div>
                    <div :key="4" v-if="state == 'getEmailForgetPassword'">
                      <div class="titleAuthBox">
                        بازیابی رمز عبور
                      </div>
                      <div class="subTitle">
                        لطفا جهت بازیابی رمز عبور، ایمیل خود را وارد کنید
                      </div>
                      <div class="formBox">
                        <div :class="showEmailError ? 'errorForm' : 'customInputGrey'" cols="12" lg="6">
                          <v-text-field @keydown.native.enter="sendEmailForgetPassword" v-model="email" outlined
                                        :color="showEmailError ? 'red' : 'black'"
                                        label="ایمیل"></v-text-field>
                          <div v-if="showEmailError" class="red--text hintAreaAuth mb-5 d-flex">
                            <div>
                              <img src="../../assets/image/user-journey/info-circle-red.svg" alt="">
                            </div>
                            <div class="mr-1 d-flex justify-center flex-column">
                              شما قبلا با این ایمیل حساب کاربری ساخته اید
                            </div>
                          </div>
                        </div>
                        <v-btn
                            @click="sendEmailForgetPassword"
                            class="submitBtn mt-15"
                            :disabled="!email"
                            elevation="0"
                        >
                          ادامه
                        </v-btn>
                      </div>

                    </div>
                    <div :key="5" v-if="state == 'getOtpForget'">
                      <div class="titleAuthBox">
                        کد تایید
                      </div>
                      <div class="subTitle">
                        کد تایید ورود به حساب کاربری ، به
                        <b>
                          ایمیل زیر
                        </b>
                        ارسال شد
                      </div>
                      <div class="emailBox d-flex flex-column ">
                        <div class="d-flex  justify-space-between">
                          <div class="flex-grow-1 emailLabel">
                            {{ email }}
                          </div>
                          <div class="d-flex flex-column justify-center" style="cursor: pointer">
                            <img src="../../assets/image/user-journey/pencil.svg"
                                 @click="state = 'getEmailForgetPassword'"
                                 alt="">
                          </div>
                        </div>
                      </div>
                      <div class="otpArea customInputGrey">
                        <v-otp-input
                            style="direction: ltr;border-color: red"
                            @finish="submitCodeForget"
                            length="6"
                            v-model="otp"
                        ></v-otp-input>
                      </div>
                      <div class="resendArea" @click="registerWithEmail" style="cursor:pointer;">
                        کد را دریافت نکرده اید؟
                        <span style="color:#39C990;" class="mr-1">
                  ارسال مجدد
                </span>
                      </div>
                    </div>
                    <div :key="6" v-if="state == 'getPasswordForget'">
                      <div class="titleAuthBox">
                        تعریف رمز عبور
                      </div>
                      <div class="subTitle">
                        برای دسترسی آسان به حساب کاربری خود، رمز عبور تعیین کنید.
                      </div>
                      <div class="otpArea customInputGrey">
                        <v-form ref="changePhone"
                                @keydown.native.enter="savePasswordForget"
                                @submit.prevent="savePasswordForget()"
                        >
                          <v-text-field
                              v-model="password"
                              outlined
                              :type="typePassword"
                              color="black"
                              placeholder="رمز عبور">
                            <template v-slot:append>
                              <div style="cursor: pointer">
                                <img v-if="typePassword == 'password'" @click="typePassword = 'text'"
                                     src="../../assets/image/user-journey/eye-off.svg" alt="">
                                <img @click="typePassword = 'password'" v-else
                                     src="../../assets/image/user-journey/eye.svg">
                              </div>
                            </template>
                          </v-text-field>
                          <v-text-field
                              style="margin-top: -15px"
                              v-model="RePassword"
                              :type="typeRePassword"
                              outlined
                              color="black"
                              placeholder="تکرار رمز عبور">
                            <template v-slot:append>
                              <div style="cursor: pointer">
                                <img v-if="typeRePassword == 'password'" @click="typeRePassword = 'text'"
                                     src="../../assets/image/user-journey/eye-off.svg" alt="">
                                <img @click="typeRePassword = 'password'" v-else
                                     src="../../assets/image/user-journey/eye.svg">
                              </div>
                            </template>
                          </v-text-field>
                        </v-form>
                        <div class="hintAreaAuthPassword ">
                          <div class="hintItem d-flex">
                            <div class="hintIcon d-flex flex-column justify-center">
                              <img src="../../assets/image/user-journey/check-list-active.svg"
                                   v-if="validations.minLength"
                                   alt="">
                              <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                            </div>
                            <div class="hintText mr-1 d-flex flex-column justify-center">
                              حداقل ۸ کاراکتر
                            </div>
                          </div>
                          <div class="hintItem d-flex">
                            <div class="hintIcon d-flex flex-column justify-center">
                              <img src="../../assets/image/user-journey/check-list-active.svg"
                                   v-if="validations.upperLower"
                                   alt="">
                              <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                            </div>
                            <div class="hintText mr-1 d-flex flex-column justify-center">
                              شامل حروف انگلیسی بزرگ و کوچک
                            </div>
                          </div>
                          <div class="hintItem d-flex">
                            <div class="hintIcon d-flex flex-column justify-center">
                              <img src="../../assets/image/user-journey/check-list-active.svg" v-if="validations.number"
                                   alt="">
                              <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                            </div>
                            <div class="hintText mr-1 d-flex flex-column justify-center">
                              استفاده از اعداد
                            </div>
                          </div>
                          <div class="hintItem d-flex">
                            <div class="hintIcon d-flex flex-column justify-center">
                              <img src="../../assets/image/user-journey/check-list-active.svg" v-if="validations.symbol"
                                   alt="">
                              <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                            </div>
                            <div class="hintText mr-1 d-flex flex-column justify-center">
                              استفاده از نمادها (مانند ! @ # $)
                            </div>
                          </div>
                        </div>

                        <div style="margin-top: 40px">
                          <v-btn
                              @click="savePasswordForget"
                              class="submitBtn"
                              elevation="0"
                              :disabled="!validations.allValid || !RePassword"
                              style="margin-bottom: 16px !important;"
                          >
                            ذخیره رمز عبور
                          </v-btn>
                          <div class="line"></div>
                          <div class="loginBtn">
                            حساب کاربری دارید؟
                            <span style="color:#39C990;">
                ورود به حساب
                        </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-fade-transition>

                </v-tab-item>
              </v-tabs-items>
            </div>
          </v-col>
        </v-row>
      </template>
      <div class="fill-height" v-else>
        <div class="authFormBox pt-8">
          <div class="headerForm" v-if="state == 'getEmailRegister'">
            <v-tabs
                v-model="tab"
                fixed-tabs
                class="pa-0 ma-0"
                color="#39C990"
            >
              <v-tab color="pa-0 ma-0" value="morning">ایجاد حساب کاربری</v-tab>
              <v-tab color="pa-0 ma-0" value="evening">ورود به حساب</v-tab>
            </v-tabs>
          </div>
          <div v-else>
            <img class="mt-2" @click="returnStep" src="../../assets/image/user-journey/arrow-narrow-right_1.svg" alt="">
          </div>
          <v-tabs-items touchless v-model="tab">
            <v-tab-item>
              <v-fade-transition mode="out-in">
                <div :key="1" v-if="state == 'getEmailRegister'">
                  <div class="titleAuthBox">
                    ایجاد حساب کاربری
                  </div>
                  <div class="subTitle">
                    لطفا ایمیل خود را جهت ایجاد حساب کاربری وارد کنید
                  </div>

                  <div class="googleAuthBtn" @click="loginWithGoogle">
                    <div class="d-flex justify-center">
                      <div class="mt-1">
                        <img src="../../assets/image/user-journey/google.png" width="16px" alt="">
                      </div>
                      <div class="mr-2 d-flex flex-column justify-center">
                        ادامه با حساب گوگل
                      </div>
                    </div>
                  </div>
                  <div class="orSection">
                    <div class="line mt-2"></div>
                    <div class="label">یا</div>
                    <div class="line mt-2"></div>
                  </div>
                  <div class="formBox">
                    <div :class="showEmailError ? 'errorForm' : 'customInputGrey'" cols="12" lg="6">
                      <v-text-field v-model="email" outlined :color="showEmailError ? 'red' : 'black'"
                                    label="ایمیل"></v-text-field>
                      <div v-if="showEmailError" class="red--text hintAreaAuth mb-5 d-flex">
                        <div>
                          <img src="../../assets/image/user-journey/info-circle-red.svg" alt="">
                        </div>
                        <div class="mr-1 d-flex justify-center flex-column">
                          شما قبلا با این ایمیل حساب کاربری ساخته اید
                        </div>
                      </div>

                    </div>
                    <v-btn
                        @click="registerWithEmail"
                        class="submitBtn"
                        :disabled="!isValidEmail"
                        elevation="0"
                    >
                      ایجاد حساب کاربری
                    </v-btn>
                  </div>
                  <div class="line"></div>

                  <div class="loginBtn">
                    حساب کاربری دارید؟
                    <span style="color:#39C990;cursor:pointer;" @click="tab = 1">
                ورود به حساب کاربری
                </span>
                  </div>
                </div>
                <div :key="2" v-if="state == 'getCodeRegister'">
                  <div class="titleAuthBox">
                    کد تایید
                  </div>
                  <div class="subTitle">
                    کد تایید ایجاد حساب کاربری ، به ایمیل زیر ارسال شد
                  </div>
                  <div class="emailBox d-flex flex-column ">
                    <div class="d-flex  justify-space-between">
                      <div class="flex-grow-1 emailLabel">
                        {{ email }}
                      </div>
                      <div class="d-flex flex-column justify-center" style="cursor: pointer">
                        <img src="../../assets/image/user-journey/pencil.svg" @click="state = 'getEmailRegister'"
                             alt="">
                      </div>
                    </div>
                  </div>
                  <div class="otpArea customInputGrey">
                    <v-otp-input
                        style="direction: ltr;border-color: red"
                        @finish="submitRegisterEmail"
                        length="6"
                        v-model="otp"
                        type="number"
                    ></v-otp-input>
                    <v-btn
                        @click="submitRegisterEmail"
                        class="submitBtn"
                        :disabled="!isValidEmail"
                        elevation="0"
                    >
                      تایید
                    </v-btn>
                  </div>
                  <div class="resendArea" @click="registerWithEmail" style="cursor:pointer;">
                    کد را دریافت نکرده اید؟
                    <span style="color:#39C990;" class="mr-1">
                  ارسال مجدد
                </span>
                  </div>
                  <div class="line"></div>
                  <div class="loginBtn">
                    میخواهید از رمز عبور استفاده کنید؟
                    <span style="color:#39C990;cursor:pointer;" @click="state = 'getPasswordRegister'">
                تعریف رمز عبور
                </span>
                  </div>
                </div>
                <div :key="3" v-if="state == 'getPhoneRegister'">
                  <div class="titleAuthBox">
                    شماره تلفن همراه
                  </div>
                  <div class="subTitle">
                    جهت یادآوری جلسات و هماهنگی سریع، لطفا شماره‌ تلفن خود را وارد کنید
                  </div>
                  <div class="otpArea customInputGrey">
                    <v-form ref="changePhone">
                      <v-text-field
                          type="tel"
                          inputmode="numeric"
                          v-model="phone"
                          :rules="phoneRulesWithMessage"
                          outlined
                          color="black"
                          label="شماره واتس اپ / تلگرام"></v-text-field>
                    </v-form>

                    <div class="hintAreaAuth d-flex">
                      <div>
                        <img src="../../assets/image/user-journey/info.svg" alt="">
                      </div>
                      <div class="mr-1 d-flex justify-center flex-column">
                        لطفاً شماره‌ای وارد کنید که در واتساپ یا تلگرام فعال باشد.
                      </div>
                    </div>

                    <div style="margin-top: 100px">
                      <v-btn
                          @click="changePhoneNumber"
                          class="submitBtn"
                          elevation="0"

                      >
                        ثبت و مشاهده تراپیست
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div :key="4" v-if="state == 'getPasswordRegister'">
                  <div class="titleAuthBox">
                    تعریف رمز عبور
                  </div>
                  <div class="subTitle">
                    برای دسترسی آسان به حساب کاربری خود، رمز عبور تعیین کنید.
                  </div>
                  <div class="otpArea customInputGrey">
                    <v-form ref="changePhone">
                      <v-text-field
                          v-model="password"
                          outlined
                          :type="typePassword"
                          color="black"
                          placeholder="رمز عبور">
                        <template v-slot:append>
                          <div style="cursor: pointer">
                            <img v-if="typePassword == 'password'" @click="typePassword = 'text'"
                                 src="../../assets/image/user-journey/eye-off.svg" alt="">
                            <img @click="typePassword = 'password'" v-else
                                 src="../../assets/image/user-journey/eye.svg">
                          </div>
                        </template>
                      </v-text-field>
                      <v-text-field
                          style="margin-top: -15px"
                          v-model="RePassword"
                          :type="typeRePassword"
                          outlined
                          color="black"
                          placeholder="تکرار رمز عبور">
                        <template v-slot:append>
                          <div style="cursor: pointer">
                            <img v-if="typeRePassword == 'password'" @click="typeRePassword = 'text'"
                                 src="../../assets/image/user-journey/eye-off.svg" alt="">
                            <img @click="typeRePassword = 'password'" v-else
                                 src="../../assets/image/user-journey/eye.svg">
                          </div>
                        </template>
                      </v-text-field>
                    </v-form>
                    <div class="hintAreaAuthPassword ">
                      <div class="hintItem d-flex">
                        <div class="hintIcon d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/check-list-active.svg"
                               v-if="validations.minLength"
                               alt="">
                          <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                        </div>
                        <div class="hintText mr-1 d-flex flex-column justify-center">
                          حداقل ۸ کاراکتر
                        </div>
                      </div>
                      <div class="hintItem d-flex">
                        <div class="hintIcon d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/check-list-active.svg"
                               v-if="validations.upperLower"
                               alt="">
                          <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                        </div>
                        <div class="hintText mr-1 d-flex flex-column justify-center">
                          شامل حروف انگلیسی بزرگ و کوچک
                        </div>
                      </div>
                      <div class="hintItem d-flex">
                        <div class="hintIcon d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/check-list-active.svg" v-if="validations.number"
                               alt="">
                          <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                        </div>
                        <div class="hintText mr-1 d-flex flex-column justify-center">
                          استفاده از اعداد
                        </div>
                      </div>
                      <div class="hintItem d-flex">
                        <div class="hintIcon d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/check-list-active.svg" v-if="validations.symbol"
                               alt="">
                          <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                        </div>
                        <div class="hintText mr-1 d-flex flex-column justify-center">
                          استفاده از نمادها (مانند ! @ # $)
                        </div>
                      </div>
                    </div>

                    <div style="margin-top: 40px">
                      <v-btn
                          @click="savePassword"
                          class="submitBtn"
                          elevation="0"
                          :disabled="!validations.allValid || !RePassword"
                          style="margin-bottom: 16px !important;"
                      >
                        ذخیره رمز عبور
                      </v-btn>
                      <div class="line"></div>
                      <div class="loginBtn">
                        حساب کاربری دارید؟
                        <span style="color:#39C990;">
                ورود به حساب
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-fade-transition>
            </v-tab-item>
            <v-tab-item>
              <v-fade-transition mode="out-in">
                <div :key="1" v-if="state == 'getEmailRegister'">
                  <div class="titleAuthBox">
                    ورود به حساب
                  </div>
                  <div class="subTitle">
                    لطفا اطلاعات خود را جهت ورود به حساب کاربری وارد کنید
                  </div>

                  <div class="googleAuthBtn" @click="loginWithGoogle">
                    <div class="d-flex justify-center">
                      <div class="mt-1">
                        <img src="../../assets/image/user-journey/google.png" width="16px" alt="">
                      </div>
                      <div class="mr-2 d-flex flex-column justify-center">
                        ادامه با حساب گوگل
                      </div>
                    </div>
                  </div>
                  <div class="orSection">
                    <div class="line mt-2"></div>
                    <div class="label">یا</div>
                    <div class="line mt-2"></div>
                  </div>
                  <div class="formBox">
                    <div :class="showEmailError ? 'errorForm' : 'customInputGrey'" cols="12" lg="6">
                      <v-text-field v-model="email" outlined :color="showEmailError ? 'red' : 'black'"
                                    label="ایمیل"></v-text-field>
                      <v-form ref="loginForm">
                        <v-text-field
                            :rules="requiredRulesWithoutMessage"
                            v-model="password"
                            outlined
                            style="margin-top: -15px"
                            :type="typePassword"
                            color="black"
                            v-if="loginMethods.password"
                            placeholder="رمز عبور">
                          <template v-slot:append>
                            <div style="cursor: pointer">
                              <img v-if="typePassword == 'password'" @click="typePassword = 'text'"
                                   src="../../assets/image/user-journey/eye-off.svg" alt="">
                              <img @click="typePassword = 'password'" v-else
                                   src="../../assets/image/user-journey/eye.svg">
                            </div>
                          </template>
                        </v-text-field>

                      </v-form>
                      <div style="margin-top: -20px;z-index: 5;position: relative">
                        <div class="loginOption" v-if="loginMethods.email" @click="sendOtpLogin">
                          ورود با رمز یکبار مصرف
                        </div>
                        <div class="loginOption" v-if="Object.keys(loginMethods).length != 0"
                             @click="state = 'getEmailForgetPassword'">
                          رمز عبورخود را فراموش کرده اید؟
                        </div>
                      </div>
                      <div v-if="showEmailError" class="red--text hintAreaAuth mb-5 d-flex">
                        <div>
                          <img src="../../assets/image/user-journey/info-circle-red.svg" alt="">
                        </div>
                        <div class="mr-1 d-flex justify-center flex-column">
                          کاربری با این ایمیل ثبت نام نکرده است
                        </div>
                      </div>

                    </div>
                    <v-btn
                        @click="Object.keys(loginMethods).length == 0 ? getLoginMethod() : login()"
                        class="submitBtn mt-5"
                        :disabled="!isValidEmail"
                        elevation="0"
                    >
                      ورود به حساب
                    </v-btn>
                  </div>
                  <div class="line"></div>

                  <div class="loginBtn">
                    حساب کاربری ندارید؟
                    <span style="color:#39C990;cursor:pointer;" @click="tab = 0">
                ایجاد حساب کاربری
                </span>
                  </div>
                </div>
                <div :key="2" v-if="state == 'getOtpLogin'">
                  <div class="titleAuthBox">
                    کد تایید
                  </div>
                  <div class="subTitle">
                    کد تایید ورود به حساب کاربری ، به
                    <b>
                      ایمیل زیر
                    </b>
                    ارسال شد
                  </div>
                  <div class="emailBox d-flex flex-column ">
                    <div class="d-flex  justify-space-between">
                      <div class="flex-grow-1 emailLabel">
                        {{ email }}
                      </div>
                      <div class="d-flex flex-column justify-center" style="cursor: pointer">
                        <img src="../../assets/image/user-journey/pencil.svg" @click="state = 'getEmailRegister'"
                             alt="">
                      </div>
                    </div>
                  </div>
                  <div class="otpArea customInputGrey">
                    <v-otp-input
                        style="direction: ltr;border-color: red"
                        @finish="submitCodeLogin"
                        length="6"
                        v-model="otp"
                    ></v-otp-input>
                    <v-btn
                        @click="submitCodeLogin"
                        class="submitBtn"
                        :disabled="!isValidEmail"
                        elevation="0"
                    >
                      تایید
                    </v-btn>
                  </div>
                  <div class="resendArea" @click="registerWithEmail" style="cursor:pointer;">
                    کد را دریافت نکرده اید؟
                    <span style="color:#39C990;" class="mr-1">
                  ارسال مجدد
                </span>
                  </div>
                </div>
                <div :key="3" v-if="state == 'getPhoneLogin'">
                  <div class="titleAuthBox">
                    شماره تلفن همراه
                  </div>
                  <div class="subTitle">
                    جهت یادآوری جلسات و هماهنگی سریع، لطفا شماره‌ تلفن خود را وارد کنید
                  </div>
                  <div class="otpArea customInputGrey">
                    <v-form ref="changePhone">
                      <v-text-field
                          type="tel"
                          inputmode="numeric"
                          v-model="phone"
                          :rules="phoneRulesWithMessage"
                          outlined
                          color="black"
                          label="شماره واتس اپ / تلگرام"></v-text-field>
                    </v-form>

                    <div class="hintAreaAuth d-flex">
                      <div>
                        <img src="../../assets/image/user-journey/info.svg" alt="">
                      </div>
                      <div class="mr-1 d-flex justify-center flex-column">
                        لطفاً شماره‌ای وارد کنید که در واتساپ یا تلگرام فعال باشد.
                      </div>
                    </div>

                    <div style="margin-top: 100px">
                      <v-btn
                          @click="changePhoneNumber"
                          class="submitBtn"
                          elevation="0"

                      >
                        ثبت و مشاهده تراپیست
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div :key="4" v-if="state == 'getEmailForgetPassword'">
                  <div class="titleAuthBox">
                    بازیابی رمز عبور
                  </div>
                  <div class="subTitle">
                    لطفا جهت بازیابی رمز عبور، ایمیل خود را وارد کنید
                  </div>
                  <div class="formBox">
                    <div :class="showEmailError ? 'errorForm' : 'customInputGrey'" cols="12" lg="6">
                      <v-text-field v-model="email" outlined :color="showEmailError ? 'red' : 'black'"
                                    label="ایمیل"></v-text-field>
                      <div v-if="showEmailError" class="red--text hintAreaAuth mb-5 d-flex">
                        <div>
                          <img src="../../assets/image/user-journey/info-circle-red.svg" alt="">
                        </div>
                        <div class="mr-1 d-flex justify-center flex-column">
                          شما قبلا با این ایمیل حساب کاربری ساخته اید
                        </div>
                      </div>
                    </div>
                    <v-btn
                        @click="sendEmailForgetPassword"
                        class="submitBtn mt-15"
                        :disabled="!email"
                        elevation="0"
                    >
                      ادامه
                    </v-btn>
                  </div>

                </div>
                <div :key="5" v-if="state == 'getOtpForget'">
                  <div class="titleAuthBox">
                    کد تایید
                  </div>
                  <div class="subTitle">
                    کد تایید ورود به حساب کاربری ، به
                    <b>
                      ایمیل زیر
                    </b>
                    ارسال شد
                  </div>
                  <div class="emailBox d-flex flex-column ">
                    <div class="d-flex  justify-space-between">
                      <div class="flex-grow-1 emailLabel">
                        {{ email }}
                      </div>
                      <div class="d-flex flex-column justify-center" style="cursor: pointer">
                        <img src="../../assets/image/user-journey/pencil.svg"
                             @click="state = 'getEmailForgetPassword'"
                             alt="">
                      </div>
                    </div>
                  </div>
                  <div class="otpArea customInputGrey">
                    <v-otp-input
                        style="direction: ltr;border-color: red"
                        @finish="submitCodeForget"
                        length="6"
                        v-model="otp"
                    ></v-otp-input>
                  </div>
                  <div class="resendArea" @click="registerWithEmail" style="cursor:pointer;">
                    کد را دریافت نکرده اید؟
                    <span style="color:#39C990;" class="mr-1">
                  ارسال مجدد
                </span>
                  </div>
                </div>
                <div :key="6" v-if="state == 'getPasswordForget'">
                  <div class="titleAuthBox">
                    تعریف رمز عبور
                  </div>
                  <div class="subTitle">
                    برای دسترسی آسان به حساب کاربری خود، رمز عبور تعیین کنید.
                  </div>
                  <div class="otpArea customInputGrey">
                    <v-form ref="changePhone">
                      <v-text-field
                          v-model="password"
                          outlined
                          :type="typePassword"
                          color="black"
                          placeholder="رمز عبور">
                        <template v-slot:append>
                          <div style="cursor: pointer">
                            <img v-if="typePassword == 'password'" @click="typePassword = 'text'"
                                 src="../../assets/image/user-journey/eye-off.svg" alt="">
                            <img @click="typePassword = 'password'" v-else
                                 src="../../assets/image/user-journey/eye.svg">
                          </div>
                        </template>
                      </v-text-field>
                      <v-text-field
                          style="margin-top: -15px"
                          v-model="RePassword"
                          :type="typeRePassword"
                          outlined
                          color="black"
                          placeholder="تکرار رمز عبور">
                        <template v-slot:append>
                          <div style="cursor: pointer">
                            <img v-if="typeRePassword == 'password'" @click="typeRePassword = 'text'"
                                 src="../../assets/image/user-journey/eye-off.svg" alt="">
                            <img @click="typeRePassword = 'password'" v-else
                                 src="../../assets/image/user-journey/eye.svg">
                          </div>
                        </template>
                      </v-text-field>
                    </v-form>
                    <div class="hintAreaAuthPassword ">
                      <div class="hintItem d-flex">
                        <div class="hintIcon d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/check-list-active.svg"
                               v-if="validations.minLength"
                               alt="">
                          <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                        </div>
                        <div class="hintText mr-1 d-flex flex-column justify-center">
                          حداقل ۸ کاراکتر
                        </div>
                      </div>
                      <div class="hintItem d-flex">
                        <div class="hintIcon d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/check-list-active.svg"
                               v-if="validations.upperLower"
                               alt="">
                          <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                        </div>
                        <div class="hintText mr-1 d-flex flex-column justify-center">
                          شامل حروف انگلیسی بزرگ و کوچک
                        </div>
                      </div>
                      <div class="hintItem d-flex">
                        <div class="hintIcon d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/check-list-active.svg" v-if="validations.number"
                               alt="">
                          <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                        </div>
                        <div class="hintText mr-1 d-flex flex-column justify-center">
                          استفاده از اعداد
                        </div>
                      </div>
                      <div class="hintItem d-flex">
                        <div class="hintIcon d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/check-list-active.svg" v-if="validations.symbol"
                               alt="">
                          <img src="../../assets/image/user-journey/check-list-inactive.svg" v-else alt="">
                        </div>
                        <div class="hintText mr-1 d-flex flex-column justify-center">
                          استفاده از نمادها (مانند ! @ # $)
                        </div>
                      </div>
                    </div>

                    <div style="margin-top: 40px">
                      <v-btn
                          @click="savePassword('getEmailRegister')"
                          class="submitBtn"
                          elevation="0"
                          :disabled="!validations.allValid || !RePassword"
                          style="margin-bottom: 16px !important;"
                      >
                        ذخیره رمز عبور
                      </v-btn>
                      <div class="line"></div>
                      <div class="loginBtn">
                        حساب کاربری دارید؟
                        <span style="color:#39C990;">
                ورود به حساب
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-fade-transition>

            </v-tab-item>
          </v-tabs-items>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AuthMixins from "@/mixins/AuthMixins";
import EventsMixins from "@/mixins/EventsMixins";
/*eslint-disable*/

export default {
  mixins: [AuthMixins, EventsMixins],
  data() {
    return {
      timezone: null,
      tab: 0,
      typePassword: 'password',
      typeRePassword: 'password',
      email: "",
      state: "getEmailRegister",
      otp: null,
      phone: null,
      showEmailError: false,
      password: null,
      RePassword: null,
      loginMethods: {},
      rules: {
        minLength: /^.{8,}$/,                      // at least 8 characters
        upperLower: /^(?=.*[a-z])(?=.*[A-Z]).+$/,  // contains uppercase & lowercase
        number: /^(?=.*\d).+$/,                    // contains number
        symbol: /^(?=.*[!@#$%^&*(),.?":{}|<>]).+$/ // contains special character
      },
    }
  },
  computed: {
    validations() {
      const minLength = this.rules.minLength.test(this.password);
      const upperLower = this.rules.upperLower.test(this.password);
      const number = this.rules.number.test(this.password);
      const symbol = this.rules.symbol.test(this.password);

      return {
        minLength,
        upperLower,
        number,
        symbol,
        allValid: minLength && upperLower && number && symbol
      };
    },
    isValidEmail() {
      // disable if empty or not email
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return this.email !== "" && pattern.test(this.email);
    },
  },
  methods: {
    loginWithGoogle() {
      window.location.href = 'https://api.simiaroom.com/api/v1/auth/social/google?redirect-to=userJourney';
    },
    sendEmailForgetPassword() {
      this.showEmailError = false
      this.otp = null
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'sendEmailOtp', {}, {
        email: this.email,
        action: 'forget'
      }).then((resp) => {
        if (resp.data.error_code) {
          if (resp.data.error_code == 1002) {
            this.showEmailError = true
          }
        } else {
          this.state = 'getOtpForget'
        }
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    sendOtpLogin() {
      this.showEmailError = false
      this.otp = null
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'sendEmailOtp', {}, {
        email: this.email,
        action: 'login'
      }).then((resp) => {
        if (resp.data.error_code) {
          if (resp.data.error_code == 1002) {
            this.showEmailError = true
          } else if (resp.data.error_code == 1003) {
            this.state = 'getOtpLogin'
          }
        } else {
          this.state = 'getOtpLogin'
        }
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    getLoginMethod() {
      if (this.email) {
        this.$emitEvent('setLoading', true)
        this.requesting('auth', 'login-methods', {}, {
          email: this.email
        }).then((resp) => {
          this.loginMethods = resp.data.login_methods
          if (!this.loginMethods.password && this.loginMethods.email) {
            setTimeout(() => {
              this.sendOtpLogin()
            }, 500)
          }
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }

    },
    login() {
      if (this.$refs.loginForm.validate()) {
        this.$emitEvent('setLoading', true)
        this.requesting('auth', 'login', '', {
          email: this.email,
          password: this.password
        }).then(() => {
          setTimeout(() => {
            this.getProfileAndCheckMobile()
          }, 500)
          this.$emitEvent('notify', {color: 'green', title: this.$t('Notify.loginSuccess'), id: 'ga_login'});
        }).catch(() => {
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }
    },
    returnStep() {
      let states = {
        'getCodeRegister': 'getEmailRegister',
        'getPhoneRegister': 'getEmailRegister',
        'getPasswordRegister': 'getCodeRegister',
        'getOtpLogin': 'getEmailRegister',
        'getPhoneLogin': 'getOtpLogin',
        'getEmailForgetPassword': 'getEmailRegister',
        'getOtpForget': 'getEmailForgetPassword',
        'getPasswordForget': 'getEmailForgetPassword',
      }
      this.state = states[this.state]
    },
    savePassword(state = null) {
      if (this.password != this.RePassword) {
        this.$emitEvent('notify', {
          color: 'red',
          title: 'رمز عبور و تکرار رمز عبور برابر نیستند',
        });
        return;
      }
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'register', {}, {
        email: this.email,
        password: this.password,
        password_confirmation: this.RePassword,
        timezone: this.timezone,
      }).then(() => {
        this.loginMethods = {}
        this.requesting('auth', 'login', {}, {
          email: this.email,
          password: this.password,
        }).then(() => {
          console.log(state, '2323232')
          if (!state) {
            setTimeout(() => {
              this.getProfileAndCheckMobile()
            }, 500)
          } else {
            this.state = state
          }
        })
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    savePasswordForget() {
      if (this.password != this.RePassword) {
        this.$emitEvent('notify', {
          color: 'red',
          title: 'رمز عبور و تکرار رمز عبور برابر نیستند',
        });
        return;
      }
      this.$emitEvent('setLoading', true)
      this.requesting('user', 'setPassword', {}, {
        password: this.password,
        password_confirmation: this.RePassword,
      }).then(() => {
        this.getProfileAndCheckMobile()
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    changePhoneNumber() {
      if (this.$refs.changePhone.validate()) {
        const mobile = this.phone.replaceAll(' ', '')
        let data = {
          mobile,
        }
        this.$emitEvent('setLoading', true)
        this.requesting('auth', 'editProfile', '', data).then((resp) => {
          const profile = resp.data.profile || {}
          this.SetAttributeTrackerService(profile.email, {
            phone: profile.mobile || mobile,
            timezone: this.timezone,
            first_name: profile.firstname,
            auth_id: profile.auth_id,
            last_name: profile.lastname,
          })
          this.$emit('getMatchTherapist')
          this.$emit('changeStateFlow', {
            state: "suggest_doctors"
          })
        }).catch(() => {
          this.$emitEvent('setLoading', false)
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      } else {
        this.$emitEvent('notify', {color: 'red', title: 'شماره تماس خود را به صورت صحیح وارد کنید',});
      }
    },
    submitRegisterEmail() {
      if (!this.otp) {
        this.$emitEvent('notify', {color: 'red', title: 'کد را وارد کنید',});
        return;
      }
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'submitEmailOtp', {}, {
        email: this.email,
        action: 'register',
        otp: this.otp,
        redirected_from: 'platroom',
        timezone: this.timezone,
      }).then(() => {
        setTimeout(() => {
          this.getProfileAndCheckMobile()
        }, 500)
      }).finally(() => {
        setTimeout(() => {
          this.$emitEvent('setLoading', false)
        }, 1000)
      })
    },

    submitCodeForget() {
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'submitEmailOtp', {}, {
        email: this.email,
        action: 'forget',
        otp: this.otp,
        redirected_from: 'platroom',
      }).then(() => {
        this.state = 'getPasswordForget'
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    setTrackerAttributes(profile) {
      this.SetAttributeTrackerService(profile.email, {
        phone: profile.mobile,
        timezone: this.timezone,
        first_name: profile.firstname,
        auth_id: profile.auth_id,
        last_name: profile.lastname,
      })
    },
    getProfileAndCheckMobile() {
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'getProfile').then((resp) => {
        if (!resp.data.profile.mobile) {
          if (this.tab == 1) {
            this.state = 'getPhoneLogin'
          } else {
            this.RegisterUserInTrk().then(() => {
              this.SendEventTrk({
                event_id: 'user_journey_' + Date.now(),
                name: 'register',
                email: resp.data.profile.email,
                first_name: resp.data.profile.firstname,
                last_name: resp.data.profile.lastname,
                payload: {
                  from: 'user_journey'
                }
              })
            })
            this.state = 'getPhoneRegister'
          }
        } else {
          this.setTrackerAttributes(resp.data.profile)
          this.$emit('getMatchTherapist')
          this.$emit('changeStateFlow', {
            state: "suggest_doctors"
          })
        }
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    submitCodeLogin() {
      if (!this.otp) {
        this.$emitEvent('notify', {color: 'red', title: 'کد را وارد کنید',});
        return;
      }
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'submitEmailOtp', {}, {
        email: this.email,
        action: 'login',
        otp: this.otp,
        redirected_from: 'platroom',
      }).then(() => {
        this.$emitEvent('notify', {color: 'green', title: this.$t('Notify.loginSuccess'), id: 'ga_login'});
        setTimeout(() => {
          this.getProfileAndCheckMobile()
        }, 500)
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    registerWithEmail() {
      if (this.email) {
        this.showEmailError = false
        this.otp = null
        this.$emitEvent('setLoading', true)
        this.requesting('auth', 'sendEmailOtp', {}, {
          email: this.email,
          action: 'register'
        }).then((resp) => {
          if (resp.data.error_code) {
            if (resp.data.error_code == 1001) {
              this.showEmailError = true
            } else if (resp.data.error_code == 1003) {
              this.state = 'getCodeRegister'
            }
          } else {
            this.state = 'getCodeRegister'
          }
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }
    },
    emailRule(value) {
      if (!value) return "ایمیل الزامی است";
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return pattern.test(value) || "ایمیل معتبر نیست";
    },
  },
  created() {
    this.$onEvent('needToCheckMobileAndSubmit', () => {
      this.getProfileAndCheckMobile()
    })
  },
  watch: {
    tab() {
      this.showEmailError = false
    }
  },
  mounted() {
    this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 85)
    this.timezone = this.prepareDefaultTimezone()
  }
}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 1000px) {
  .authFormBox {
    margin-top: 0px !important;
    width: 100% !important;
    border-radius: 0px !important;
    border: none !important;
    height: 100% !important;
  }
}

.descPage {
  font-size: 16px;
  font-weight: 500;
}

.titlePage {
  margin-top: 50px;
  font-weight: 700;
  font-size: 24px;
}


.submitBtn {
  color: white !important;
}

.loginOption {
  color: #424242;
  cursor: pointer;
  text-align: right;
  margin-bottom: 8px;
  /* Body/Small/Medium14 */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
}

.hintAreaAuthPassword {
  margin-top: -20px;
}

.hintText {
  color: #616161;
  text-align: right;

  /* Body/Small/Medium14 */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
}

.resendArea {
  margin-top: 48px;
  text-align: center;
  margin-bottom: 16px;
}

.hintAreaAuth {
  color: #616161;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: -20px;
}

.otpArea {
  margin-top: 27px;
}

.emailLabel {
  color: #212121;
  /* Body/Large/Medium18 */
  font-size: 17px;
  font-family: Roboto !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.emailBox {
  margin-top: 8px;
  border-radius: 8px;
  background: #F6F9FC;
  padding: 8px 16px;

}

.loginBtn {
  margin-top: 24px;
  margin-bottom: 20px;
  text-align: center;
}


.customInputGrey .v-text-field fieldset, .v-text-field .v-input__control {
  border-color: #DBE4ED !important;
  border-radius: 8px !important;
}

/* Ensure Roboto font is used inside Vuetify text inputs within this component */
::v-deep .v-text-field input,
::v-deep .v-text-field .v-label,
::v-deep .v-text-field .v-input__control,
::v-deep .v-text-field .v-input__slot,
::v-deep .v-textarea textarea,
::v-deep .v-textarea .v-label {
  font-family: Roboto, YekanBakh !important;
}

.formBox {
  margin-top: 24px;
}

.orSection {
  display: flex;
}

.label {
  margin: 0px 8px;
  color: #424242;
  text-align: right;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.line {
  width: 100%;
  background: #EAF0F6;
  height: 1px;
  margin-top: 20px;
}

.authFormBox {
  border-radius: 16px;
  border: 1px solid #DBE4ED;
  padding: 8px 24px;
  width: 85%;
  background: white;
  margin: 30px auto 80px auto;
}

.titleAuthBox {
  margin-top: 32px;
  color: #212121;
  text-align: center;
  /* Title/Medium/Bold20 */
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.subTitle {
  color: #212121;
  text-align: center;
  /* Body/Large/Medium18 */
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 8px;
}

.googleAuthBtn {
  cursor: pointer;
  margin-top: 27px;
  margin-bottom: 27px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  height: 50px;
  border-radius: 8px;
  border: 1px solid #B8B8B8;
  background: #F6F9FC;
  width: 100%;
  color: #212121;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
}
</style>